//@ts-nocheck
import React, { useEffect } from 'react'
import Tooltip from '../Tooltip'
import { css } from '@emotion/css'
import { Icon } from '../../../../../index'

const config = {
  placement: 'bottom',
  arrow: false,
  offset: [0, 0],
  delay: [300, 0],
  duration: [0, 0],
  hideOnClick: true,
  theme: 'small',
}

export declare interface DndIconTyes extends React.HTMLAttributes<HTMLSpanElement> { }
export const DndIcon = React.forwardRef((props: DndIconTyes, ref) => {
  return (
    <Tooltip
      content={<span style={{ fontSize: '12px', fontFamily: 'Inter', fontWeight: 500 }}>Drag to move</span>}
      config={config}
    >
      <span
        ref={ref}
        data-testid="dnd-icon"
        className={css`
          display: flex;
          align-items: center;
          width: 100%;
        `}
      >
        <Icon version='v2' icon='DragAndDrop' size='small' />
      </span>
    </Tooltip>
  )
})
